/**
 * `/code-review/filters` — *Filters* section.
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewFilters() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="filters"
        title="Filters"
        subtitle="Skip reviews that don't match these gates."
      />
    </main>
  );
}
